import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { useAuth } from '../../features/auth/useAuth';
import { Uitleg } from '../../features/uitleg/Uitleg';
import { uitlegHoortOpenTeGaan } from '../../features/uitleg/opengaan';
import { Foutgrens } from '../Foutgrens';
import { AppSidebar } from './AppSidebar';
import { SiteHeader } from './SiteHeader';

/**
 * De omlijsting: zijbalk met de navigatie, header met de titel en het
 * gebruikersmenu. De navigatie zelf en welke items iemand mag zien staan in
 * `AppSidebar` — hier alleen hoe het op het scherm valt.
 *
 * De uitleg hangt hier en niet in een scherm: hij gaat vanzelf open bij de
 * eerste keer inloggen, waar je ook binnenkomt, en het menu in de header opent
 * hem daarna opnieuw.
 */
export function Layout() {
  const location = useLocation();
  const { user, meldUitlegGezien } = useAuth();
  const [uitlegOpen, setUitlegOpen] = useState(false);

  useEffect(() => {
    if (uitlegHoortOpenTeGaan(user)) setUitlegOpen(true);
  }, [user]);

  function sluitUitleg() {
    setUitlegOpen(false);
    if (user && !user.uitlegGezien) void meldUitlegGezien();
  }

  return (
    <SidebarProvider>
      <AppSidebar />
      {/* `min-w-0` is hier geen opmaak maar een reparatie, en hij hoort op dit
          element. `SidebarInset` is een flexkind van de zijbalkrij en komt uit
          shadcn met `w-full flex-1` maar zonder `min-w-0`. Een flexkind heeft
          standaard `min-width: auto` en kan dus niet smaller worden dan zijn
          eigen inhoud: één lange regel ergens diep in een scherm maakte de hele
          pagina breder dan het venster. Daardoor liepen de deelonderwerpen op het
          onderwerpenscherm buiten de kaart en hielp `max-w-full` daar niets, want
          honderd procent van een te brede ouder is nog steeds te breed.

          Met deze regel bepaalt het venster de breedte en buigt de inhoud mee.
          Wat echt niet smaller kan, zoals een brede tabel, hoort zijn eigen
          `overflow-x` te krijgen in plaats van de pagina op te rekken. */}
      <SidebarInset className="min-w-0">
        {/* De uitleg is van iedereen met een inlog, dus het menu-item ook. */}
        <SiteHeader onUitleg={() => setUitlegOpen(true)} />
        <main className="flex flex-1 flex-col gap-4 p-4 md:p-6">
          {/* Per scherm: een fout in het ene scherm mag de navigatie en de rest
              van de app niet meenemen. De sleutel wist de fout bij navigatie. */}
          <Foutgrens sleutel={location.pathname}>
            <Outlet />
          </Foutgrens>
        </main>
      </SidebarInset>

      <Uitleg onSluit={sluitUitleg} open={uitlegOpen} />
    </SidebarProvider>
  );
}
